import type { QueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { withPerformedAction } from "web_myplann/Api/Portfolio/withPerformedAction";
import type {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
	PortfolioAlertBoxDTO,
	PortfolioAlertBoxListResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const recordPerformedActionInCaches = (
	queryClient: QueryClient,
	contractId: number,
	matches: (alert: PortfolioAlertBoxDTO) => boolean,
	action: AlertBoxActionEnum,
	state: AlertBoxActionStateEnum,
) => {
	queryClient.setQueriesData<PortfolioAlertBoxListResponseDTO | undefined>(
		{ queryKey: PortfolioKeys.alertBoxesAll(contractId) },
		(previous) =>
			previous
				? {
						...previous,
						alerts: previous.alerts.map((alert) =>
							matches(alert)
								? withPerformedAction(alert, action, state)
								: alert,
						),
					}
				: previous,
	);
};

export const matchesEvent =
	(eventType: PortfolioAlertBoxDTO["eventType"], eventDate: string) =>
	(alert: PortfolioAlertBoxDTO) =>
		alert.eventType === eventType && alert.eventDate === eventDate;
